<template>
    <div class="widget" :class="theme">
        <i class="icon icon-share" />
    </div>
</template>

<script>
export default {
    name : 'shareMarker',
    props: {
        theme: {
            type   : String,
            default: 'black',
        },
    },
};
</script>

<style lang="scss" scoped>
.widget {
    width: var(--nav-content-height, 44px);
    height: var(--nav-content-height, 44px);
    box-sizing: border-box;
    padding: $padding * 0.5;

    .icon {
        display: block;
        width: 100%;
        height: 100%;

        background-repeat: no-repeat;
        background-position: center center;
        background-size: $padding $padding;
    }
    .icon-share {
        background-image: url(/static/icon/share_black.png);
    }

    &.white {
        .icon-share {
            background-image: url(/static/icon/share.png);
        }
    }
}
</style>
